import { render, staticRenderFns } from "./ValidityCheck.vue?vue&type=template&id=4546ab50&scoped=true"
var script = {}
import style0 from "./ValidityCheck.vue?vue&type=style&index=0&id=4546ab50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546ab50",
  null
  
)

export default component.exports